module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-order-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "180px"
          },
          attrs: {
            "placeholder": "用户 / 企业 / 价格",
            "clearable": ""
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getList(1)
            }
          },
          model: {
            value: (_vm.searchText),
            callback: function($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "160px"
          },
          attrs: {
            "placeholder": "类型",
            "clearable": ""
          },
          model: {
            value: (_vm.souchs.souType),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "souType", $$v)
            },
            expression: "souchs.souType"
          }
        }, _vm._l((_vm.types), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "160px"
          },
          attrs: {
            "placeholder": "订单",
            "clearable": ""
          },
          model: {
            value: (_vm.souchs.souAccount),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "souAccount", $$v)
            },
            expression: "souchs.souAccount"
          }
        }, _vm._l((_vm.accountTypes), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
          staticStyle: {
            "width": "180px"
          },
          attrs: {
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd",
            "type": "date",
            "placeholder": "开始日期时间"
          },
          model: {
            value: (_vm.souchs.fromtime),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "fromtime", $$v)
            },
            expression: "souchs.fromtime"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
          staticStyle: {
            "width": "180px"
          },
          attrs: {
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd",
            "type": "date",
            "placeholder": "结束日期时间"
          },
          model: {
            value: (_vm.souchs.totime),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "totime", $$v)
            },
            expression: "souchs.totime"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getList(1)
            }
          }
        }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": _vm.addList
          }
        }, [_vm._v("新增")])], 1)], 1), _vm._v(" "), _vm._l((_vm.dynamicTags), function(tag) {
          return _c('el-tag', {
            key: tag,
            attrs: {
              "closable": "",
              "disable-transitions": false
            },
            on: {
              "close": function($event) {
                return _vm.handleClose(tag)
              }
            }
          }, [_vm._v(" \n              " + _vm._s(tag) + " \n          ")])
        }), _vm._v(" "), (_vm.dynamicTags != '') ? _c('el-button', {
          staticClass: "button-new-tag",
          attrs: {
            "size": "small"
          },
          on: {
            "click": _vm.delTags
          }
        }, [_vm._v("清除标签")]) : _vm._e()], 2)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.dataList,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "selection-change": _vm.selsChange,
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "id",
            "label": "ID",
            "min-width": "200",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "用户",
            "min-width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.userid ? scope.row.name : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "usercompany",
            "label": "企业",
            "min-width": "260",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.userid ? scope.row.usercompany : scope.row.name))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "intime",
            "label": "时间",
            "min-width": "180",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "adminusername",
            "label": "操作人",
            "min-width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "price2",
            "label": "价格(元)",
            "min-width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "typename",
            "label": "类型",
            "min-width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag",
                class: scope.row.type == 1 ? 'primary' : 'success'
              }, [_vm._v(_vm._s(scope.row.typename))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "type": "stateverify",
            "label": "订单状态",
            "width": "120"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag",
                class: scope.row.stateverify == 1 ? 'warning' : 'primary'
              }, [_vm._v(_vm._s(scope.row.stateverify == 1 ? "申请中" : '审核通过'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "type": "isrenew",
            "label": "续订订单",
            "width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag-fill",
                class: scope.row.isrenew == 2 ? 'pruple' : 'primary'
              }, [_vm._v(_vm._s(scope.row.isrenew == 2 ? "是" : '否'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "fixed": "right",
            "min-width": "140"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "详情",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconfile-search",
                on: {
                  "click": function($event) {
                    return _vm.handleDetail(scope.$index, scope.row, 1)
                  }
                }
              })]), _vm._v(" "), (scope.row.adminuserid == _vm.userInfo.id && scope.row.stateverify == 1) ? [(scope.row.isrenew != 2) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "编辑",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconEdit",
                on: {
                  "click": function($event) {
                    return _vm.handleEdit(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "撤销",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconundo",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })])] : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1 && scope.row.stateverify == 1) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "审核",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconapprove",
                on: {
                  "click": function($event) {
                    return _vm.handleDetail(scope.$index, scope.row, 2)
                  }
                }
              })]) : _vm._e()], 2)]
            }
          }])
        })], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b65cf61"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/orderList/OrderList.vue
// module id = 1776
// module chunks = 9